import * as Sentry from "@sentry/react";
import type { User } from "@sentry/react";

export const InitSentry = (): void => {
    if (import.meta.env.VITE_FLYNT_ENV === "production") {
        Sentry.init({
            dsn: import.meta.env.VITE_SENTRY_DSN,
            integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
            sendDefaultPii: true,
            tracesSampleRate: 1.0,
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0,
        });
    }
};

export const SetSentryUserContext = (user: User): void => {
    if (user.adminId) {
        Sentry.setTag("user-admin-role", "true");
    }
    Sentry.setUser(user);
};

export const CaptureSentryError = (error: Error, errorInfo: Record<string, any>): void => {
    Sentry.withScope((scope) => {
        Object.keys(errorInfo).forEach((key) => {
            scope.setExtra(key, errorInfo[key]);
        });
        Sentry.captureException(error);
    });
};
